// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DesktopOutlinedSvg from "@ant-design/icons-svg/es/asn/DesktopOutlined";
import AntdIcon from '../components/AntdIcon';

var DesktopOutlined = function DesktopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DesktopOutlinedSvg
  }));
};

DesktopOutlined.displayName = 'DesktopOutlined';
export default React.forwardRef(DesktopOutlined);